export default "__VITE_ASSET__BTD5ly1S__"